import React, { useState, useRef, useEffect } from "react";
import Forestreet from "../../../src/assets/Forestreet.svg";
import DownloadFileFormat from '../../../src/assets/DownloadFileFormat.svg'
// import { handleDomToImgDownloadPdf } from "../../utils/utils";
import { Icon, Tooltip, Modal } from "pepsico-ds";
import domtoimage from "dom-to-image";
import domtoimagejpeg from 'dom-to-image-more';
import jsPDF from "jspdf";
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'

const DropdownWithIcons = ({modalRef, kpiName, isModal=false, checkPDFDownloaded, isTable=false}) => {
  const [open, setOpen] = useState(false);
  const [isExcel, setIsExcel] = useState(false);
  const [showInprogressModal, setShowInprogressModal] = useState(false)
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setOpen(!open);
  const { showToast } = useToast();

  
  async function trimImageWhitespace(dataUrl) {
    const img = new Image();
    img.src = dataUrl;
    await new Promise((res, rej) => {
      img.onload = res;
      img.onerror = rej;
    });
  
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
  
    const w = canvas.width;
    const h = canvas.height;
    const imgData = ctx.getImageData(0, 0, w, h).data;
  
    // helper tests whether a pixel is 'non-white/non-transparent'
    const isContent = (i) => {
      const r = imgData[i], g = imgData[i + 1], b = imgData[i + 2], a = imgData[i + 3];
      if (a > 10) { // some alpha means content
        // treat near-white as background; adjust threshold as needed
        return !(r > 245 && g > 245 && b > 245);
      }
      return false;
    };
  
    let top = 0, bottom = h - 1, left = 0, right = w - 1;
    let found = false;
  
    // top
    for (let yy = 0; yy < h; yy++) {
      for (let xx = 0; xx < w; xx++) {
        if (isContent((yy * w + xx) * 4)) {
          top = yy;
          found = true;
          break;
        }
      }
      if (found) break;
    }
    if (!found) return dataUrl; // blank image
  
    // bottom
    for (let yy = h - 1; yy >= 0; yy--) {
      for (let xx = 0; xx < w; xx++) {
        if (isContent((yy * w + xx) * 4)) {
          bottom = yy;
          yy = -1; // break outer
          break;
        }
      }
    }
    // left
    found = false;
    for (let xx = 0; xx < w; xx++) {
      for (let yy = top; yy <= bottom; yy++) {
        if (isContent((yy * w + xx) * 4)) {
          left = xx;
          found = true;
          break;
        }
      }
      if (found) break;
    }
    // right
    found = false;
    for (let xx = w - 1; xx >= 0; xx--) {
      for (let yy = top; yy <= bottom; yy++) {
        if (isContent((yy * w + xx) * 4)) {
          right = xx;
          found = true;
          break;
        }
      }
      if (found) break;
    }
  
    const cropW = right - left + 1;
    const cropH = bottom - top + 1;
    if (cropW <= 0 || cropH <= 0) return dataUrl;
  
    const out = document.createElement("canvas");
    out.width = cropW;
    out.height = cropH;
    out.getContext("2d").drawImage(canvas, left, top, cropW, cropH, 0, 0, cropW, cropH);
    return out.toDataURL("image/png");
  }
  
  if(!isTable) {
    checkPDFDownloaded = (isPdfDownloaded, isModal, fileURL, isExcel, isTable, isJpeg) => {
      if(isPdfDownloaded){
          if(isModal){
              showToast('success', !isJpeg ? "PDF of full page successfully downloaded." : 'JPEG of full page successfully downloaded.', {
                  icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
              });
          } else if(isTable){
              showToast('success', !isJpeg ? "PDF of a table successfully downloaded." : 'JPEG of a table successfully downloaded.', {
                  icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
              });
          }
          else{
              showToast('success', !isJpeg ? "PDF of a chart successfully downloaded.": 'JPEG of a chart successfully downloaded.', {
                  icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
              });
          }
      }
      else{
          showToast('Error', "Failed to download. Please try again.", {
              icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
          });
      }   
    }
  }
  

  
  
  const handleDomToImgDownloadPdf = async (ref, kpiName, option, opts=[]) => {
    setShowInprogressModal(true)
    if(option == "Download as XLS") {
        checkPDFDownloaded(false, isModal, "", true, isTable,false)
        setShowInprogressModal(false)
        return
    } else if(option == "Download as JPEG") {
        const node = ref.current;
    
        const style = {
          backgroundColor: '#ffffff', // Needed for JPEG
          padding: '10px',
        };
    
        domtoimagejpeg.toJpeg(node, { quality: 1.0, style })
          .then((dataUrl) => {
            const link = document.createElement('a');
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, "0");
            const dd = String(today.getDate()).padStart(2, "0");
            const formattedDate = `${yyyy}${mm}${dd}`;
            link.download = `${kpiName}_${formattedDate}.jpeg`;
            link.href = dataUrl;
            link.click();
            checkPDFDownloaded(true, isModal, '', false, isTable, true,true)
            setShowInprogressModal(false)
          })
          .catch((error) => {
            setShowInprogressModal(false)
            console.error('Error exporting chart as JPEG', error);
            checkPDFDownloaded(false, isModal, '', false, isTable, true,true)
          });

          return

    }


   
    
    const {
      fitMode = "top",      // 'contain' | 'cover' | 'top'
      imageScale = 2,         // 1 = native; 2 = double resolution (better for upscaling)
      marginMm = 8,           // page margin in mm
      trimWhitespace = false, // slow, optional: trims uniform white/transparent borders
      pdfFormat = "a4",
      orientation = "portrait",
    } = opts;

    const node = ref.current
     try {
     const dataUrl = await domtoimage.toPng(node, {
          bgcolor: "#ffffff", // avoid transparency causing trim issues
          quality: 1,
          cacheBust: true,
          // Render at a higher pixel size to avoid blur when we scale up in the PDF.
          width: node.scrollWidth * imageScale,
          height: node.scrollHeight * imageScale,
          style: {
            transform: `scale(${imageScale})`,
            transformOrigin: "top left",
     }});

     // optional: trim whitespace pixels from edges (slow)
    const finalDataUrl = trimWhitespace ? await trimImageWhitespace(dataUrl) : dataUrl;

     const pdf = new jsPDF({
         orientation: "portrait",
         unit: "mm",
         format: "a4", // A2 paper size
     });

     const imgProps = pdf.getImageProperties(finalDataUrl);
    if (!imgProps || !imgProps.width || !imgProps.height) {
      throw new Error("Invalid image properties from generated image.");
    }

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const usableW = pageWidth - 2 * marginMm;
    const usableH = pageHeight - 2 * marginMm;

    // Start by fitting to usable width (same approach you had)
    let pdfWidth = usableW;
    let pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    if (fitMode === "contain") {
      // If height overflows, shrink to usable height instead (maintain aspect)
      if (pdfHeight > usableH) {
        pdfHeight = usableH;
        pdfWidth = (imgProps.width * pdfHeight) / imgProps.height;
      }
    } else if (fitMode === "cover") {
      // If fitted height is smaller than usable, scale up to cover the usable height
      // (this will likely make pdfWidth > usableW and will crop horizontally,
      // but removes top/bottom whitespace)
      if (pdfHeight < usableH) {
        const scaleUp = usableH / pdfHeight;
        pdfWidth *= scaleUp;
        pdfHeight = usableH;
      }
      // (If pdfHeight already > usableH then we're already covering vertically.)
    } else if (fitMode === "top") {
      // Fit by width, but align to top margin instead of centering.
      if (pdfHeight > usableH) {
        pdfHeight = usableH;
        pdfWidth = (imgProps.width * pdfHeight) / imgProps.height;
      }
    } else {
      // fallback to contain
      if (pdfHeight > usableH) {
        pdfHeight = usableH;
        pdfWidth = (imgProps.width * pdfHeight) / imgProps.height;
      }
    }

    // compute placement (x,y in mm) — allow negative if cover produced bigger width
    const x = (pageWidth - pdfWidth) / 2;
    const y = fitMode === "top" ? marginMm : (pageHeight - pdfHeight) / 2;

    pdf.addImage(finalDataUrl, "PNG", x, y, pdfWidth, pdfHeight);

     const pdfBlob = pdf.output("blob");
     const fileURL = URL.createObjectURL(pdfBlob);
    
    // filename
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${yyyy}${mm}${dd}`;
    const fileName = `${kpiName || "export"}_${formattedDate}.pdf`;

    pdf.save(fileName);
    checkPDFDownloaded(true, isModal, fileURL, false, isTable)
    setShowInprogressModal(false)
  } catch (err) {
    checkPDFDownloaded(false, isModal, "", false, isTable)
    console.error("Failed to generate PDF:", err);
    setShowInprogressModal(false)
  }
};


//   const handleDomToImgDownloadPdf = async (ref, kpiName, option, opts=[]) => {

//     if(option == "Download as XLS") {
//         checkPDFDownloaded(false, isModal, "", true, isTable)
//         return
//     }

//     const {
//       fitMode = "top",      // 'contain' | 'cover' | 'top'
//       imageScale = 2,         // 1 = native; 2 = double resolution (better for upscaling)
//       marginMm = 8,           // page margin in mm
//       trimWhitespace = false, // slow, optional: trims uniform white/transparent borders
//       pdfFormat = "a4",
//       orientation = "portrait",
//     } = opts;

//     const node = ref.current
//      try {
//      const dataUrl = await domtoimage.toPng(node, {
//           bgcolor: "#ffffff", // avoid transparency causing trim issues
//           quality: 1,
//           cacheBust: true,
//           // Render at a higher pixel size to avoid blur when we scale up in the PDF.
//           width: node.scrollWidth * imageScale,
//           height: node.scrollHeight * imageScale,
//           style: {
//             transform: `scale(${imageScale})`,
//             transformOrigin: "top left",
//      }});

//      // optional: trim whitespace pixels from edges (slow)
//     const finalDataUrl = trimWhitespace ? await trimImageWhitespace(dataUrl) : dataUrl;

//      const pdf = new jsPDF({
//          orientation: "portrait",
//          unit: "mm",
//          format: "a4", // A2 paper size
//      });

//      const imgProps = pdf.getImageProperties(finalDataUrl);
//     if (!imgProps || !imgProps.width || !imgProps.height) {
//       throw new Error("Invalid image properties from generated image.");
//     }

//     const pageWidth = pdf.internal.pageSize.getWidth();
//     const pageHeight = pdf.internal.pageSize.getHeight();
//     const usableW = pageWidth - 2 * marginMm;
//     const usableH = pageHeight - 2 * marginMm;

//     // Start by fitting to usable width (same approach you had)
//     let pdfWidth = usableW;
//     let pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

//     if (fitMode === "contain") {
//       // If height overflows, shrink to usable height instead (maintain aspect)
//       if (pdfHeight > usableH) {
//         pdfHeight = usableH;
//         pdfWidth = (imgProps.width * pdfHeight) / imgProps.height;
//       }
//     } else if (fitMode === "cover") {
//       // If fitted height is smaller than usable, scale up to cover the usable height
//       // (this will likely make pdfWidth > usableW and will crop horizontally,
//       // but removes top/bottom whitespace)
//       if (pdfHeight < usableH) {
//         const scaleUp = usableH / pdfHeight;
//         pdfWidth *= scaleUp;
//         pdfHeight = usableH;
//       }
//       // (If pdfHeight already > usableH then we're already covering vertically.)
//     } else if (fitMode === "top") {
//       // Fit by width, but align to top margin instead of centering.
//       if (pdfHeight > usableH) {
//         pdfHeight = usableH;
//         pdfWidth = (imgProps.width * pdfHeight) / imgProps.height;
//       }
//     } else {
//       // fallback to contain
//       if (pdfHeight > usableH) {
//         pdfHeight = usableH;
//         pdfWidth = (imgProps.width * pdfHeight) / imgProps.height;
//       }
//     }

//     // compute placement (x,y in mm) — allow negative if cover produced bigger width
//     const x = (pageWidth - pdfWidth) / 2;
//     const y = fitMode === "top" ? marginMm : (pageHeight - pdfHeight) / 2;

//     pdf.addImage(finalDataUrl, "PNG", x, y, pdfWidth, pdfHeight);

//      const pdfBlob = pdf.output("blob");
//      const fileURL = URL.createObjectURL(pdfBlob);
    
//     // filename
//     const today = new Date();
//     const yyyy = today.getFullYear();
//     const mm = String(today.getMonth() + 1).padStart(2, "0");
//     const dd = String(today.getDate()).padStart(2, "0");
//     const formattedDate = `${yyyy}${mm}${dd}`;
//     const fileName = `${kpiName || "export"}_${formattedDate}.pdf`;

//     pdf.save(fileName);
//     checkPDFDownloaded(true, isModal, fileURL, false, isTable)
//   } catch (err) {
//     checkPDFDownloaded(false, isModal, "", false, isTable)
//     console.error("Failed to generate PDF:", err);
//   }
// };

  // close dropdown when clicked outside
  
  
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const isTableKpis =
    kpiName?.includes('Category_Forums_Calendar') ||
    kpiName?.includes('Contract Boards details') ||
    kpiName?.includes('Product Price Details') ||
    kpiName?.includes('Contract Boards Outcomes Summary') ||
    kpiName?.includes('Contract Boards Action Items');
  const options = [
    ...(!isTable
      ? [
          {
            label: "Download as PDF",
            icon: (
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_400_531382)">
                  <path d="M3.225 0C2.345 0 1.633 0.72 1.633 1.6L1.625 14.4C1.625 15.28 2.337 16 3.217 16H12.825C13.705 16 14.425 15.28 14.425 14.4V4.8L9.625 0H3.225ZM8.825 5.6V1.2L13.225 5.6H8.825Z" fill="#8D466D"/>
                </g>
                <defs>
                  <clipPath id="clip0_400_531382">
                    <rect width="16" height="16" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            ),
          },
        ]
      : []),
    ...(isTable
      ? [
          {
            label: "Download as XLS",
            icon: (
              <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.225 0C1.345 0 0.633 0.72 0.633 1.6L0.625 14.4C0.625 15.28 1.337 16 2.217 16H11.825C12.705 16 13.425 15.28 13.425 14.4V4.8L8.625 0H2.225ZM7.825 5.6V1.2L12.225 5.6H7.825Z" fill="#008553"/>
              </svg>

            ),
          },
        ]
      : []),
    ...(!isTable
      ? [
          {
            label: "Download as JPEG",
            icon: (
              <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.225 0C1.345 0 0.633 0.72 0.633 1.6L0.625 14.4C0.625 15.28 1.337 16 2.217 16H11.825C12.705 16 13.425 15.28 13.425 14.4V4.8L8.625 0H2.225ZM7.825 5.6V1.2L12.225 5.6H7.825Z" fill="#8458CC"/>
              </svg>

            ),
          },
        ]
      : []),
  ];
  

  
  return (
    <div ref={dropdownRef} 
         style={{ position: "relative", display: "inline-block", background: 'white', 
                  height: '30px', borderRadius: '5px', border: '1px solid #d3caca'}}>
      {/* Trigger Button */}
      <div style={{display: 'flex'}}>
      <Tooltip text={isModal ? 'Download Full Page' : isTable ? 'Download this table' : 'Download this chart'} direction={isModal ? "left": "top-middle"} style={{display: 'flex !important', zIndex: '999999'}}>
        <button
          onClick={toggleDropdown}
          style={{
            background: "white",
            border: "none",
            cursor: "pointer",
            display: 'flex',
            position: 'relative',
            top: '0.35rem'
          }}
        >
          <Icon
            alt="alt value"
            icon={"download"}
            size="small"
            style={{ color: '#005cbc' }}
          />
          <Icon
            alt="alt value"
            icon={"arrow_drop_down"}
            size="small"
            style={{ color: '#005cbc' }}
          />
          {/* <img src={DownloadFileFormat} alt="download" /> */}
        </button>
      </Tooltip>
      </div>

      {/* Dropdown Menu */}
      {open && (
        <ul
          style={{
            position: "absolute",
            // top: "120%",
            right: 0,
            background: "white",
            listStyle: "none",
            padding: "4px 0",
            margin: 0,
            border: "1px solid #ddd",
            borderRadius: "6px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            minWidth: "150px",
            fontSize: "12px",
            zIndex: '99999'
          }}
        >
          {options.map((opt, idx) => (
            <li
              key={idx}
              role="button"
              tabIndex={0}
              style={{
                padding: "0 5px",
                display: "flex",
                alignItems: "center",
                height: '1.5rem',
                cursor: "pointer",
              }}
              onClick={() => {
                handleDomToImgDownloadPdf(modalRef, kpiName, opt.label)
                setOpen(false);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleDomToImgDownloadPdf(modalRef, kpiName, opt.label);
                  setOpen(false);
                }
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#f5f5f5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "transparent")
              }
            >
              {opt.icon}
              <span style={{ marginLeft: "6px", fontWeight: '500' }}>{opt.label}</span>
            </li>
          ))}
        </ul>
      )}

{
                                showInprogressModal ? (
                                    <>
                                        <Modal
                                          
                                            closeOnOutsideClick={false}
                                            hideCloseButton
                                            //   onCloseModal={function oFe(){setInactiveModal(false)}}
                                            //   primaryButtonProps={{
                                            //     onClick: handleContinue,
                                            //     size: 'medium',
                                            //     text: 'Continue',
                                            //     variant: 'primary'
                                            //   }}
                                            //   secondaryButtonProps={{
                                            //     onClick: handleExitEditorMode,
                                            //     size: 'medium',
                                            //     text: 'Exit',
                                            //     variant: 'tertiary'
                                            //   }}
                                            showModal={true}
                                            showPrimaryButton={false}
                                              showLink={false}
                                                showSecondaryButton={false}
                                                showTertiaryButton={false}
                                                showAuxiliaryButton={false}
                                            type="S"
                                            >
                                                <div>
                                                    <div className="download-inprogress-text">Downloading In Progress... </div>
                                                </div>
                                            </Modal>
                                        
                                    </>
                                ) : <></>
                            }



                                          
    </div>
  );
};

export default DropdownWithIcons;
